import React from "react";
import greySmall from "../../assets/logo/grey-small.svg";
import greyLarge from "../../assets/logo/grey-large.svg";
import horizontalSmall from "../../assets/logo/horizontal-small.svg";
import horizontalLarge from "../../assets/logo/horizontal-large.svg";
import logoOnlyLarge from "../../assets/logo/logo-only-large.svg";
import verticalSmall from "../../assets/logo/vertical-small.svg";
import verticalLarge from "../../assets/logo/vertical-large.svg";

export enum LogoType {
  Grey = "grey",
  Horizontal = "horizontal",
  LogoOnly = "logo",
  Vertical = "vertical",
}

interface LogoProps {
  type: LogoType;
}
const Logo: React.FC<LogoProps> = ({ type }) => {
  if (type === LogoType.Grey) {
    return (
      <div>
        <img className="display-mobile" src={greySmall} alt="logo" />
        <img className="display-desktop" src={greyLarge} alt="logo" />
      </div>
    );
  } else if (type === LogoType.Horizontal) {
    return (
      <div>
        <img className="display-mobile" src={horizontalSmall} alt="logo" />
        <img className="display-desktop" src={horizontalLarge} alt="logo" />
      </div>
    );
  } else if (type === LogoType.LogoOnly) {
    return (
      <div>
        <img src={logoOnlyLarge} alt="logo" />
      </div>
    );
  } else {
    return (
      <div>
        <img className="display-mobile" src={verticalSmall} alt="logo" />
        <img className="display-desktop" src={verticalLarge} alt="logo" />
      </div>
    );
  }
};

export default Logo;
